import URL from '@/mocks/urls';

import { CONTACT_EMAIL, CONTACT_PHONE } from '@/mocks/contacts';

import {
  PRIVACY_POLICY_PAGE,
  TERMS_CONDITIONS_PAGE,
} from '@/constants/pagesUrl';

import Microsoft from 'images/microsoft-gold-partner-logo.png';
import Ifst from 'images/ifst-logo.png';
import Cecod from 'images/cecod-logo.png';
import BicaLogo from 'images/bica-logo.png';
import LantLogo from 'images/lantzerath-group-logo.png';

const FooterData = {
  navigation: [
    {
      title: 'Features',
      url: URL.navigation.features.title,
      sub_navigation: [
        {
          title: 'Feature',
          url: URL.navigation.features.sub_nav.feature_1,
        },
        {
          title: 'Feature',
          url: URL.navigation.features.sub_nav.feature_2,
        },
        {
          title: 'Feature',
          url: URL.navigation.features.sub_nav.feature_3,
        },
        {
          title: 'Feature',
          url: URL.navigation.features.sub_nav.feature_4,
        },
      ],
    },
    {
      title: 'Our focus',
      url: URL.navigation.our_focus.title,
      sub_navigation: [
        {
          title: 'Gas Stations',
          url: URL.navigation.our_focus.sub_nav.gas_stations,
        },
        {
          title: 'Convenience Retail',
          url: URL.navigation.our_focus.sub_nav.convenience_retail,
        },
        {
          title: 'Hospitality',
          url: URL.navigation.our_focus.sub_nav.hospitality,
        },
        {
          title: 'Store retail',
          url: URL.navigation.our_focus.sub_nav.store_retail,
        },
      ],
    },
    {
      title: 'About',
      url: URL.navigation.about.title,
      sub_navigation: [
        {
          title: 'Company',
          url: URL.navigation.about.sub_nav.company,
        },
        {
          title: 'Management',
          url: URL.navigation.about.sub_nav.management,
        },
        {
          title: 'Work with us',
          url: URL.navigation.about.sub_nav.work_with_us,
        },
        {
          title: 'Contact us',
          url: URL.navigation.about.sub_nav.contact_us,
        },
      ],
    },
    {
      title: 'Help',
      url: URL.navigation.help.title,
      sub_navigation: [
        {
          title: 'FAQs',
          url: URL.navigation.help.sub_nav.faqs,
        },
        {
          title: 'Knowledgebase',
          url: URL.navigation.help.sub_nav.knowledgebase,
        },
      ],
    },
  ],
  contacts: {
    subscribe: {
      title: 'Subscribe to our digest:',
      subtitle: 'Markets insights, news and new features  at glance',
    },
    socials: {
      title: 'Connect to Cirrusoft.',
      subtitle: 'We are in Social Media',
    },
    support: {
      title: 'Need help?',
      subtitle: 'Our support team is ready to help!',
    },
    mail: CONTACT_EMAIL,
    tel: CONTACT_PHONE,
  },
  info: {
    privacy: {
      text: 'Privacy policy',
      url: PRIVACY_POLICY_PAGE,
    },
    terms: {
      text: 'Terms & Conditions',
      url: TERMS_CONDITIONS_PAGE,
    },
    copy: {
      text: 'All right reserved',
    },
    partners: {
      title: 'cirrusoft associations and partners ',
      list: [Microsoft, Ifst, Cecod],
    },
    owners: [
      {
        title: 'DISCOVER BICA SOLUTIONS FOR GAS STATION RETAIL',
        logo: BicaLogo,
      },
      {
        title: 'CIRRUSOFT IS A PART OF LANTZERATH GROUP',
        logo: LantLogo,
      },
    ],
  },
};

export default FooterData;
